import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    AlterarTipoRelacaoClienteController,
    ListarTipoRelacaoClienteController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";
import { ITipoRelacaoCliente } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoRelacaoCliente/TipoRelacaoClienteInterface";
import SpinnerComponent from "../../../../../Loding/Spinner";
import Table from "../../../../../Table";

export default function TipoRelacaoCliente() {
    const [lstTipoRelacaoCliente, setLstTipoRelacaoCliente] =
        useState<Array<ITipoRelacaoCliente>>();
    useEffect(() => {
        updateListaTipoRelacaoCliente();
    }, []);

    function updateListaTipoRelacaoCliente() {
        ListarTipoRelacaoClienteController().then((response) => {
            setLstTipoRelacaoCliente(response);
        });
    }

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_TIPO_RELACAO_CLIENTE",
            text: "Tipos de Relação Cliente",
            editable: true,
        },
    ];

    return lstTipoRelacaoCliente ? (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12 mt-5">
                    <Table
                        keyField="TIPO_RELACAO_CLIENTE"
                        columns={columns}
                        data={lstTipoRelacaoCliente}
                        bordered={false}
                        edit={{
                            onEdit: async (cell, row) => {
                                AlterarTipoRelacaoClienteController({
                                    ...row,
                                    DS_TIPO_RELACAO_CLIENTE: cell,
                                }).then(updateListaTipoRelacaoCliente);
                            },
                        }}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
